import _ from 'lodash';
import classnames from 'classnames';
import React from 'react';
import TZDate from '../services/TZDate';
import { formatTime } from '../services/dateHelpers';

import { normalizeTableOpeningHours } from '../services/openingHours';

function OpeningHoursTableColumn(
  { day, dayLabel, openingHours, noteId, styles, translation }
) {
  let openingHoursHTML;

  if (openingHours.length) {
    openingHoursHTML = openingHours.map(({ from, to }) => (
      <div className="OpeningHoursTable__FromTo">
        <span>{formatTime(from, styles.timeFormat.value)}</span>
        <span> – </span>
        <span>{formatTime(to, styles.timeFormat.value)}</span>
      </div>
    ));
  } else {
    openingHoursHTML = (
      <div className="OpeningHoursTable__FromTo">
        <span>{translation.closed_standalone}</span>
      </div>
    );
  }

  // TODO: do we need to factor in the timezone here?
  const currentDay = new TZDate().getDayString().toLowerCase();
  const isToday = currentDay === day;

  return (
    <div
      className={classnames(
        'modal-highlight-border OpeningHoursTable__Column',
        {
          'OpeningHoursTable__Column--active': isToday,
          'OpeningHoursTable__Column--highlight': noteId
        }
      )}
    >
      {/*
      {noteId &&
        <div className="modal-highlight-background OpeningHoursTable__Footnote">
          {noteId}
        </div>}
        */}
      {/* <div className="OpeningHoursTable__Today"><small>today</small></div>*/}
      <div className="OpeningHoursTable__Day">
        {dayLabel} {noteId && <span>{noteId}</span>}
      </div>
      <div className="OpeningHoursTable__OpeningHours">{openingHoursHTML}</div>
    </div>
  );
}

function TableFooter({ notes }) {
  const renderedNotes = notes.map((note, i) => (
    <div className="OpeningHoursTable__Note">
      <div className="OpeningHoursTable__NoteId modal-highlight-background">
        {i + 1}
      </div>
      <div className="OpeningHoursTable__NoteTitle">{note}</div>
    </div>
  ));

  return (
    <div className="OpeningHoursTable__Footer">
      {renderedNotes}
    </div>
  );
}

function OpeningHoursTable(
  {
    headline,
    openingHoursByDay,
    specialOpeningHours,
    styles,
    translation
  }
) {
  const firstDayOfWeek = _.get(styles, 'firstDayOfWeek.value', 'monday');
  const normalized = normalizeTableOpeningHours(
    firstDayOfWeek,
    openingHoursByDay,
    specialOpeningHours
  );

  const notes = normalized.reduce(
    (memo, { note }) => {
      if (note && memo.indexOf(note) === -1) {
        memo.push(note);
      }
      return memo;
    },
    []
  );

  // Render each weekday
  const columns = normalizeTableOpeningHours(
    firstDayOfWeek,
    openingHoursByDay,
    specialOpeningHours
  ).map(({ note, day, openingHours }) => {
    // Use ID to reference note in footer
    const noteId = note && notes.indexOf(note) + 1;
    const dayLabel = translation[day];

    return (
      <OpeningHoursTableColumn
        noteId={noteId}
        key={day}
        day={day}
        dayLabel={dayLabel}
        openingHours={openingHours}
        styles={styles}
        translation={translation}
      />
    );
  });

  return (
    <div className="OpeningHoursTable">
      <div className="OpeningHoursTableHeadline">
        <h1>{headline ? headline : translation.businessHours}</h1>
      </div>
      <div className="OpeningHoursTableWrapper">
        {columns}
      </div>

      {notes.length ? <TableFooter notes={notes} /> : null}
    </div>
  );
}

export default OpeningHoursTable;



// WEBPACK FOOTER //
// ./src/commons/components/OpeningHoursTable.jsx